module.exports = __webpack_public_path__ + "static/mariam-mortada-804bf17c6ddd237e009b91f7ce95c884.png";